<template>
  <div id="app">
    <!-- header：滚动 或 下拉打开 时都变白 -->
    <div ref="header" class="header"
      :style="{ 'background-color': (scrolled || dropdownOpen) ? '#ffffff' : 'transparent', 'border-bottom': (scrolled || dropdownOpen) ? '1px solid #eee' : 'none' }">
      <div class="header_center">
        <!-- Logo 区域 -->
        <div class="logo_img" @click="logoClick">
          <div class="header-logo">
            <img class="header-img" src="../assets/logo.png" />
          </div>
          <div class="header-important">
            <div class="company_name">云稼科技</div>
          </div>
        </div>

        <!-- 菜单区域（完全手写，不用 el-menu 的弹出） -->
        <div class="menu_index">
          <div class="nav-list">
            <template v-for="(item, index) in menuList">
              <!-- 无子菜单 -->
              <div v-if="!item.children || item.children.length === 0" :key="'solo-' + index" class="nav-item"
                :class="{ 'nav-item--active': activeIndex === String(index) }" @click="goMenu(item)">
                {{ item.label }}
              </div>
              <!-- 有子菜单：click 展开/收起 -->
              <div v-else :key="'group-' + index" class="nav-item nav-item--has-children"
                :class="{ 'nav-item--active': activeIndex === String(index), 'nav-item--open': dropdownOpen && dropdownIndex === index }"
                @click.stop="toggleDropdown(index)">
                {{ item.label }}
                <i v-if="dropdownOpen && dropdownIndex === index" class="el-icon-arrow-up caret"></i>
                <i v-else class="el-icon-arrow-down caret"></i>
              </div>
            </template>
          </div>
        </div>

        <!-- 登录按钮区域 -->
        <div class="header-right">
          <el-button type="primary" size="small" class="header-title" @click="register">登录</el-button>
        </div>
      </div>

      <!-- ============ 自定义全屏 mega-dropdown ============ -->
      <transition name="dropdown">
        <div v-if="dropdownOpen" class="mega-dropdown">
          <div class="dropdown-inner">
            <!-- 顶部大标题 -->
            <div class="dropdown-title-wrap">
              <span class="dropdown-title-bar"></span>
              <span class="dropdown-title">{{ dropdownTitle }}</span>
            </div>
            <!-- 2×4 方案卡片网格 -->
            <div class="dropdown-grid">
              <router-link v-for="(child, idx) in activeChildren" :key="idx" :to="{ name: child.name }"
                class="dropdown-card" :class="{ 'dropdown-card--current': $route.name === child.name }"
                @click.native="closeDropdown">
                <img class="item-icon" :src="child.icon" alt="" />
                <div class="item-label">{{ child.label }}</div>
                <i class="item-arrow">›</i>
              </router-link>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div class="container" style="clear: both">
      <router-view></router-view>
    </div>

    <div v-if="$route.meta.showFooter" class="bottom">
      <Footer></Footer>
    </div>
    <div v-if="$route.meta.showFooter" id="back_to_top" ref="btn" @click="backTop" style="display: none">
      <div class="top_text">TOP</div>
      <img src="../assets/other/launch.png" style="height: 45px; width: 35px" />
    </div>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
export default {
  name: "Layout",
  components: {
    Footer,
  },
  watch: {
    $route: {
      handler(newVal) {
        this.handleActiveIndex(newVal.path);
      },
      immediate: true,
    },
  },
  computed: {
    activeChildren() {
      if (this.dropdownIndex >= 0 && this.menuList[this.dropdownIndex]) {
        return this.menuList[this.dropdownIndex].children || [];
      }
      return [];
    },
    dropdownTitle() {
      if (this.dropdownIndex >= 0 && this.menuList[this.dropdownIndex]) {
        return this.menuList[this.dropdownIndex].label;
      }
      return "";
    },
  },
  data() {
    return {
      scrolled: false,
      dropdownOpen: false,
      dropdownIndex: -1,
      activeIndex: "0",
      scroll: "",
      timer: "",
      seen: true,
      currentMenu: "首页",
      menuList: [
        { path: "/", name: "Index", label: "首页" },
        { path: "/product", name: "Product", label: "产品中心" },
        {
          label: "解决方案",
          children: [
            { path: "/solution/digitalSupply", name: "DigitalSupply", label: "数字供销全域治理", icon: require("@/assets/solution/solutionNavMenuIcon/digitalSupply.png") },
            { path: "/solution/smartAgri", name: "SmartAgri", label: "智慧农业生产数字化", icon: require("@/assets/solution/solutionNavMenuIcon/smartAgri.png") },
            { path: "/solution/agriSupply", name: "AgriSupply", label: "农资供应链数字化", icon: require("@/assets/solution/solutionNavMenuIcon/agriSupply.png") },
            { path: "/solution/agriService", name: "AgriService", label: "农业社会化服务生态", icon: require("@/assets/solution/solutionNavMenuIcon/agriService.png") },
            { path: "/solution/productTrace", name: "ProductTrace", label: "农产品产销溯源", icon: require("@/assets/solution/solutionNavMenuIcon/productTrace.png") },
            { path: "/solution/aiAgent", name: "AIAgent", label: "云小稼AI智能体", icon: require("@/assets/solution/solutionNavMenuIcon/aiAgent.png") },
            { path: "/solution/dataTwin", name: "DataTwin", label: "数据智能与孪生可视化", icon: require("@/assets/solution/solutionNavMenuIcon/dataTwin.png") },
            { path: "/solution/customDev", name: "CustomDev", label: "定制化平台开发", icon: require("@/assets/solution/solutionNavMenuIcon/customDev.png") },
          ],
        },
        { path: "/case", name: "Case", label: "成功案例" },
        { path: "/about", name: "About", label: "关于云稼" },
        { path: "/contact", name: "Contact", label: "联系我们" },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener("click", this.handleDocClick);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("click", this.handleDocClick);
  },
  methods: {
    handleActiveIndex(path) {
      if (path === "/" || path === "") {
        this.activeIndex = "0";
        return;
      }
      const idx = this.menuList.findIndex((item) => item.path === path);
      if (idx !== -1) {
        this.activeIndex = String(idx);
        return;
      }
      for (let i = 0; i < this.menuList.length; i++) {
        const item = this.menuList[i];
        if (item.children && item.children.length) {
          const childIdx = item.children.findIndex((c) => c.path === path);
          if (childIdx !== -1) {
            this.activeIndex = String(i);
            return;
          }
        }
      }
    },
    goMenu(item) {
      if (item.path && item.name) {
        this.$router.push({ name: item.name });
        this.currentMenu = item.label;
      }
      this.closeDropdown();
    },
    // ========== 自定义 mega-dropdown 控制（click 驱动） ==========
    toggleDropdown(index) {
      if (this.dropdownOpen && this.dropdownIndex === index) {
        this.closeDropdown();
      } else {
        this.dropdownIndex = index;
        this.dropdownOpen = true;
      }
    },
    closeDropdown() {
      this.dropdownOpen = false;
      this.dropdownIndex = -1;
    },
    handleDocClick(e) {
      if (this.dropdownOpen && this.$refs.header && !this.$refs.header.contains(e.target)) {
        this.closeDropdown();
      }
    },
    handleScroll() {
      this.scroll =
        document.documentElement.scrollTop + document.body.scrollTop;
      if (this.scroll > 600) {
        this.$refs.btn && (this.$refs.btn.style.display = "block");
      } else {
        this.$refs.btn && (this.$refs.btn.style.display = "none");
      }
      this.scrolled = window.scrollY > 100;
    },
    backTop() {
      this.timer = setInterval(() => {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(this.timer);
        }
      }, 30);
    },
    login() {
      window.open("https://main.yungia.cn/#/login");
    },
    register() {
      window.open("https://main.yungia.cn/#/login");
    },
    record() {
      window.open("https://beian.miit.gov.cn");
    },
    logoClick() {
      this.$router.push({ name: "Index" });
      this.currentMenu = "首页";
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 620px;
}

#back_to_top {
  position: fixed;
  bottom: 50px;
  right: 30px;
  cursor: pointer;
  font-size: 0;

  .top_text {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
  }
}

.header-title {
  font-size: 16px;
}

.company_name {
  font-weight: 400;
  font-size: 22px;
  color: #3982f7;
  font-family: "PangMenZhengDao-3";
}

.footer_font {
  font-size: 1em;
}

/* ---------- Flex 布局 ---------- */
.header {
  margin: auto;
  width: 100%;
  height: 64px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 999900;
  transition: background-color 0.3s ease;

  .header_center {
    width: 1196px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 99990110;

    .logo_img {
      display: flex;
      align-items: center;
      cursor: pointer;
      flex-shrink: 0;

      .header-logo {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
      }

      .header-img {
        width: 30px;
        height: 30px;
        display: block;
      }

      .header-important {
        margin-left: 8px;
        display: flex;
        align-items: center;
      }
    }

    .menu_index {
      flex: 1;
      display: flex;
      align-items: center;
      margin-left: 48px;
      height: 100%;

      .nav-list {
        display: flex;
        align-items: center;
        height: 100%;
      }

      .nav-item {
        font-size: 16px;
        color: #333;
        padding: 0 16px;
        height: 64px;
        line-height: 64px;
        cursor: pointer;
        position: relative;
        user-select: none;
        white-space: nowrap;
        transition: color 0.2s ease;

        &:hover {
          color: #3982f7;
        }

        &--active {
          color: #3982f7;
        }

        &--open {
          color: #3982f7;
        }

        .caret {
          display: inline-block;
          font-size: 12px;
          margin-left: 4px;
          transition: color 0.2s ease;
        }
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }
  }
}
</style>

<!-- ============ mega-dropdown 全局样式 ============ -->
<style lang="scss">
/* ===== mega-dropdown：全屏宽度，紧贴 header ===== */
.mega-dropdown {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  background: #ffffff;
  border-bottom: 1px solid #eef0f4;
  padding-top: 80px;
  padding-bottom: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

  .dropdown-inner {
    width: 1196px;
    margin: 0 auto;
    padding: 24px 0 28px;
    box-sizing: border-box;
  }

  /* 顶部大标题 */
  .dropdown-title-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 18px;

    .dropdown-title-bar {
      width: 3px;
      height: 18px;
      background: #3982f7;
      border-radius: 2px;
      margin-right: 10px;
    }

    .dropdown-title {
      font-family: PingFang SC;
      font-weight: 400;
      font-style: Regular;
      font-size: 14px;
      leading-trim: NONE;
      line-height: 100%;
      letter-spacing: 0%;
      color: #666666;
    }
  }

  /* 2 × 4 grid */
  .dropdown-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
  }

  .dropdown-card {
    display: flex;
    align-items: center;
    height: 60px;
    padding: 0 14px;
    border-radius: 10px;
    background: #F9FBFF;
    border: 1px solid #eef0f4;
    color: #3a4050;
    text-decoration: none;
    font-size: 14px;
    transition: all 0.2s ease;

    .item-icon {
      width: 26px;
      height: 26px;
      margin-right: 12px;
      flex-shrink: 0;
      display: block;
      object-fit: cover;
    }

    .item-label {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.4;
      font-family: PingFang SC;
      font-weight: 500;
      font-style: Medium;
      font-size: 15px;
      leading-trim: NONE;
      line-height: 100%;
      letter-spacing: 0%;
      color: #333;
    }

    .item-arrow {
      opacity: 0;
      color: #3982f7;
      font-size: 18px;
      font-weight: 700;
      transition: opacity 0.2s ease, transform 0.2s ease;
    }

    &:hover {
      background: #3982F71A;
      color: #3982f7;
      border-color: #3982F72A;

      .item-arrow {
        opacity: 1;
        transform: translateX(2px);
      }
    }

    &--current {
      background: #3982F71A;
      color: #3982f7;
      border-color: #3982F72A;

      .item-arrow {
        opacity: 1;
        transform: translateX(2px);
      }
    }
  }
}

/* ===== 下拉过渡动画 ===== */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
  transform-origin: top center;
}

.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>